// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__2YZXC","popup":"Select_popup__3ipkJ","isSelectProduct":"Select_isSelectProduct__3TVkO"};